import React, { useId } from 'react';
import { Link } from 'react-router-dom';

export interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  clickable?: boolean;
  /** Called after navigation when `clickable` (e.g. close mobile menu). */
  onNavigate?: () => void;
  'aria-label'?: string;
}

export default function Logo({
  size = 'md',
  clickable = true,
  onNavigate,
  'aria-label': ariaLabel = 'ShieldSME home',
}: LogoProps) {
  const gradId = `shieldGrad-${useId().replace(/:/g, '')}`;

  const sizes = {
    sm: { shield: 24, text: '16px' },
    md: { shield: 32, text: '20px' },
    lg: { shield: 48, text: '28px' },
  };

  const s = sizes[size];

  const content = (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: clickable ? 'pointer' : 'default',
      }}
    >
      <svg
        width={s.shield}
        height={s.shield}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0a0f1e" />
            <stop offset="100%" stopColor="#111827" />
          </linearGradient>
        </defs>
        <path
          d="M50 5 L90 20 L90 50 C90 72 72 88 50 95 C28 88 10 72 10 50 L10 20 Z"
          fill={`url(#${gradId})`}
          stroke="#00ff88"
          strokeWidth={4}
        />
        <text
          x={50}
          y={63}
          fontFamily="Inter, Arial, sans-serif"
          fontSize={40}
          fontWeight={700}
          fill="#00ff88"
          textAnchor="middle"
        >
          S
        </text>
      </svg>
      <span
        style={{
          fontSize: s.text,
          fontWeight: 700,
          fontFamily: 'Inter, sans-serif',
          color: 'var(--text-primary)',
          letterSpacing: '-0.5px',
        }}
      >
        Shield
        <span style={{ color: 'var(--accent-green)' }}>SME</span>
      </span>
    </div>
  );

  if (clickable) {
    return (
      <Link
        to="/"
        className="inline-flex no-underline text-inherit"
        aria-label={ariaLabel}
        onClick={() => onNavigate?.()}
      >
        {content}
      </Link>
    );
  }

  return content;
}
